module.exports = __webpack_public_path__ + "img/LNB_event.8e9cfbab.svg";